<template>
  <div class="case animate__animated together init--zzQhF" id="hzCase">
    <div class="case_box_main maxWidth">
      <div class="box_introduce-main-title size_center">
        <div>合作案例</div>
        <div></div>
      </div>
      <div class="case_box" id="box">
        <!-- Swiper -->
        <div class="ImageBox">
          <el-carousel
            :autoplay="true"
            ref="carousel"
            indicator-position="none"
            :interval="3000"
            type="card"
            :height="500 / 80 + 'rem'"
          >
            <el-carousel-item
              v-for="(item, index) in engineGameList"
              :key="index"
            >
              <div class="box_body">
                <div class="ImageBox_slideshow">
                  <img :src="item.img" alt="千年游戏盒子" />
                </div>
                <div class="ImageBox_info">{{ item.name }}</div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <!-- 前进后退按钮 -->
          <div
            class="LeftButton"
            @click="previous('prev')"
            :class="leftButton ? 'leftButton_bg1' : 'leftButton_bg'"
          ></div>
          <div
            class="RightButton"
            @click="next"
            :class="rightButton ? 'rightButton_bg1' : 'rightButton_bg'"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      leftButton: false,
      rightButton: false,
    };
  },
  created() {},
  mounted() {},
  computed: {
		...mapState({
			engineGameList: (state) => state.init.engineGameList,
		})
	},
  methods: {
    // 合作案例 上一页
    previous(value) {
      this.$refs.carousel.prev();
      this.leftButton = true;
      this.rightButton = false;
    },
    // 合作案例 下一页
    next() {
      this.$refs.carousel.next();
      this.leftButton = false;
      this.rightButton = true;
    },
  },
};
</script>

<style scoped lang="scss">
.case {
  height: 11rem /* 880/80 */;
  background: #fff;
}
.case_box_main {
  height: 100%;
  background: #fff;
}

.box_introduce-main-title > div:nth-child(1) {
  font-size: 0.45rem /* 36/80 */;
  color: #000000;
  padding-top: 0.775rem /* 62/80 */;
  margin-bottom: 0.3125rem /* 25/80 */;
  font-weight: 700;
}

.box_introduce-main-title div:nth-child(2) {
  width: 10.875rem /* 870/80 */;
  height: 1px;
  margin: 0 auto;
  background: linear-gradient(to right, #f9f8f5, #cac9c9 50%, #f9f8f5);
}
.case_box {
  margin-top: 1.65rem /* 132/80 */;
  position: relative;
  height: 4.9625rem /* 397/80 */;
}

.ImageBox {
  width: 12.125rem /* 970/80 */;
  margin: 0 auto;
  position: relative;
}

.ImageBox .el-carousel__mask {
  opacity: 0;
  /* background-color: rgba(0, 0, 0, 0.35); */
}

.ImageBox .ImageBox_info {
  padding: 0.1625rem /* 13/80 */ 0 0.3375rem /* 27/80 */ 0.2625rem /* 21/80 */;
  color: #000000;
  font-size: 0.25rem /* 20/80 */;
}

.ImageBox .ImageBox_slideshow {
  height: 3.5625rem /* 285/80 */;
  height: 3.75rem /* 300/80 */;
  border-radius: 0.125rem /* 10/80 */ 0.125rem /* 10/80 */ 0px 0px;
  overflow: hidden;
  position: relative;
}

.box_body {
  margin: 0 auto;
  width: 88%;
  height: 90%;
  background-color: #fff;
  border-radius: 0.125rem /* 10/80 */;
  box-shadow: 0px 0.125rem 0.3625rem 1px rgba(0, 0, 0, 0.13);
}

.ImageBox .is-in-stage {
  height: 5rem /* 400/80 */;
}

.ImageBox .is-in-stage .ImageBox_slideshow::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(to bottom right, #000, #000);
  opacity: 0.6;
}

.ImageBox .is-active .ImageBox_slideshow::after {
  content: "";
  display: none;
}

.ImageBox .is-active {
  height: 5.625rem /* 450/80 */;
}

.ImageBox .is-active .box_body {
  margin: 0 auto;
  width: 88%;
  height: 81%;
  background-color: #fff;
  border-radius: 0.125rem /* 10/80 */;
  box-shadow: 0px 0.125rem 0.3625rem 1px rgba(0, 0, 0, 0.35);
}

.ImageBox .is-active .ImageBox_slideshow {
  height: 3.8625rem /* 309/80 */;
}

.ImageBox .ImageBox_slideshow img {
  display: block;
  width: 100%;
  height: 100%;
}

.el-carousel__indicators--outside {
  display: none;
}

.case_box .RightButton {
  position: absolute;
  right: -0.825rem /* 66/80 */;
  top: 30%;
  transform: translateY(-34%);
  width: 0.7375rem /* 59/80 */;
  height: 1.8375rem /* 147/80 */;
  cursor: pointer;
}

.case_box .LeftButton {
  position: absolute;
  left: -0.825rem /* 66/80 */;
  top: 30%;
  transform: translateY(-34%);
  width: 0.7375rem /* 59/80 */;
  height: 1.8375rem /* 147/80 */;
  cursor: pointer;
}

.case_box .leftButton_bg {
  background: url("../../assets/images/pc/prevButton.png") no-repeat center;
  background-size: cover;
}

.case_box .leftButton_bg1 {
  background: url("../../assets/images/pc/prevButton1.png") no-repeat center;
  background-size: cover;
}

.case_box .rightButton_bg {
  background: url("../../assets/images/pc/nextButton.png") no-repeat center;
  background-size: cover;
}

.case_box .rightButton_bg1 {
  background: url("../../assets/images/pc/nextButton1.png") no-repeat center;
  background-size: cover;
}

.case_box_swiper {
  width: 12.125rem /* 970/80 */;
  height: 5.4rem /* 432/80 */;
}

.box_img_shadow {
  width: 5.0375rem /* 403/80 */;
  background: #ffffff;
  border-radius: 0.125rem /* 10/80 */;
}

.case_box .swiper-slide {
  height: 4.9625rem /* 397/80 */;
  box-shadow: 0px 0.125rem 0.3625rem 1px rgba(0, 0, 0, 0.13);
  background-image: linear-gradient(to bottom right, #eee, #ccc);
}

.case_box .swiper-slide-active {
  box-shadow: 0px 0.125rem 0.3625rem 1px rgba(0, 0, 0, 0.35);
  background-image: none;
}

.case_box1_img {
  width: 100%;
  height: 4.175rem /* 334/80 */;
  background: url("../../assets/images/pc/case_box1.jpg") no-repeat;
  background-size: cover;
}

::v-deep .ImageBox .el-carousel__arrow--left {
  display: none !important;
}

::v-deep .ImageBox .el-carousel__arrow--right {
  display: none !important;
}
::v-deep .el-carousel__item--card{
  height: 5rem /* 400/80 */;
}
</style>
